exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n.topDiv{\n  padding-top: 59px;\n  background: whitesmoke;\n  height: 100vh;\n}\n\n.rowStyle{\n \n  height: 84vh;\n  \n  }\n\n  #deviceTable input {\n    border-radius: 5px;\n  }\n\n  ::-webkit-scrollbar {\n    width: 10px;\n  }\n  \n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: rgb(153, 153, 153); \n  }\n   \n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n  \n    background: #868e96;\n  }\n  \n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: #555; \n  }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/driver-detail/driver-detail.component.css
// module id = ../../../../../src/app/driver-detail/driver-detail.component.css
// module chunks = main